
import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DurationUtility } from '@jms/model';

@Pipe({ name: 'stringifyDuration', standalone: true })
export class StringifyDurationPipe implements PipeTransform {

    transform(value: number): string {
        return DurationUtility.stringify(value);
    }
}

@Pipe({ name: 'parseDuration', standalone: true })
export class ParseDurationPipe implements PipeTransform {

    transform(value: string): number {
        return DurationUtility.parse(value);
    }
}

@NgModule({
    imports: [
        CommonModule,
        StringifyDurationPipe,
        ParseDurationPipe
    ],
    declarations: [

    ],
    providers: [
        StringifyDurationPipe,
        ParseDurationPipe
    ],
    exports: [
        StringifyDurationPipe,
        ParseDurationPipe
    ],
})
export class DurationPipeModule { }